import { render, staticRenderFns } from "./lookSingleExam.vue?vue&type=template&id=540fc26e&scoped=true&"
import script from "./lookSingleExam.vue?vue&type=script&lang=js&"
export * from "./lookSingleExam.vue?vue&type=script&lang=js&"
import style0 from "./lookSingleExam.vue?vue&type=style&index=0&id=540fc26e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540fc26e",
  null
  
)

export default component.exports